import i18n from '@/i18n/i18n'
import SettingsService from '@/services/admin/SettingsService.js'
import { errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const state = {
  settings: null,
  setting: {}
}

export const mutations = {
  SET_SETTINGS(state, settings) {
    state.settings = settings.data
  },
  SET_SETTING(state, setting) {
    state.setting = setting.data
  },
  DELETE_SETTING(state, settingToRemove) {
    state.settings = state.settings.filter(setting => {
      return setting.id !== settingToRemove.id
    })
  }
}

export const actions = {
  getSettings({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      SettingsService.getSettings()
        .then(response => {
          commit('SET_SETTINGS', response)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSetting({ commit }, id) {
    return new Promise((resolve, reject) => {
      SettingsService.getSetting(id)
        .then(response => {
          commit('SET_SETTING', response)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  toggleSetting({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      SettingsService.toggleSetting(params.settingId, params.settingVal)
        .then(response => {
          commit('SET_SETTINGS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.update_error', {
                element: t('store.admin.settings.setting_value')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createSetting({ commit, dispatch }, setting) {
    return new Promise((resolve, reject) => {
      SettingsService.createSetting(setting)
        .then(response => {
          commit('SET_SETTINGS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.adding_problem', {
                element: t('store.admin.settings.setting')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateSetting({ state, commit, dispatch }, setting) {
    return new Promise((resolve, reject) => {
      SettingsService.updateSetting(state.setting.id, setting)
        .then(response => {
          commit('SET_SETTINGS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.update_error', {
                element: t('store.admin.settings.setting')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteSetting({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      SettingsService.deleteSetting(params.id)
        .then(response => {
          commit('DELETE_SETTING', params)
          const notification = {
            type: 'success',
            message: t('store.shared.deleted', {
              element: t('store.admin.settings.setting')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.delete_error', {
                element: t('store.admin.settings.setting')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
